/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Status_Generating_XmlInputs */

const en_image_export_status_generating_xml = /** @type {(inputs: Image_Export_Status_Generating_XmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating BDN XML script...`)
};

const fr_image_export_status_generating_xml = /** @type {(inputs: Image_Export_Status_Generating_XmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generation du script XML BDN...`)
};

const de_image_export_status_generating_xml = /** @type {(inputs: Image_Export_Status_Generating_XmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generiere BDN-XML-Skript...`)
};

const it_image_export_status_generating_xml = /** @type {(inputs: Image_Export_Status_Generating_XmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generazione dello script XML BDN in corso...`)
};

const ru_image_export_status_generating_xml = /** @type {(inputs: Image_Export_Status_Generating_XmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Генерация XML-скрипта BDN...`)
};

const es_image_export_status_generating_xml = /** @type {(inputs: Image_Export_Status_Generating_XmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generando script XML BDN...`)
};

const zh_cn2_image_export_status_generating_xml = /** @type {(inputs: Image_Export_Status_Generating_XmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在生成 BDN XML 脚本...`)
};

const ja_image_export_status_generating_xml = /** @type {(inputs: Image_Export_Status_Generating_XmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BDN XML スクリプトを生成しています...`)
};

const hi_image_export_status_generating_xml = /** @type {(inputs: Image_Export_Status_Generating_XmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बीडीएन एक्सएमएल स्क्रिप्ट तैयार की जा रही है...`)
};

const pt_pt2_image_export_status_generating_xml = /** @type {(inputs: Image_Export_Status_Generating_XmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerando script XML BDN...`)
};

/**
* | output |
* | --- |
* | "Generating BDN XML script..." |
*
* @param {Image_Export_Status_Generating_XmlInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_status_generating_xml = /** @type {((inputs?: Image_Export_Status_Generating_XmlInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Status_Generating_XmlInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_status_generating_xml(inputs)
	if (locale === "de") return de_image_export_status_generating_xml(inputs)
	if (locale === "it") return it_image_export_status_generating_xml(inputs)
	if (locale === "ru") return ru_image_export_status_generating_xml(inputs)
	if (locale === "es") return es_image_export_status_generating_xml(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_status_generating_xml(inputs)
	if (locale === "ja") return ja_image_export_status_generating_xml(inputs)
	if (locale === "hi") return hi_image_export_status_generating_xml(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_status_generating_xml(inputs)
	return en_image_export_status_generating_xml(inputs)
});